import { ColumnDefTemplate, HeaderContext } from '@tanstack/react-table';
import { useAmplitude } from 'hooks/useAmplitude';
import { TApplication } from 'lendingApi/applications.types';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';

export const useTrackFilter = (
  filterName:
    | ColumnDefTemplate<HeaderContext<TApplication, unknown>>
    | undefined,
) => {
  const { trackEvent } = useAmplitude();

  const trackFilterApplied = (filterValue: string | string[]) => {
    trackEvent(AMPLITUDE_EVENTS.tableFilterOptionApplied, {
      'Filter name': filterName,
      'Filter value': filterValue,
    });
  };

  const trackRangeFilterApplied = (from: string, to: string) => {
    trackEvent(AMPLITUDE_EVENTS.tableFilterOptionApplied, {
      'Filter name': filterName,
      From: from,
      To: to,
    });
  };

  const trackFilterReset = () => {
    trackEvent(AMPLITUDE_EVENTS.tableFilterOptionCleared, {
      'Filter name': filterName,
    });
  };

  return {
    trackFilterReset,
    trackFilterApplied,
    trackRangeFilterApplied,
  };
};
